<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn flat color="blue" block v-on="on"
          ><v-icon left>mail</v-icon> Enviar Email</v-btn
        >
      </template>
      <v-card>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card-title>
            <span class="headline primary--text"
              >Enviar Correo a {{ representante_nombre }}</span
            >
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="usuario.nombre"
                    label="Nombre*"
                    hint="Ingrese su nombre"
                    :rules="[(v) => !!v || 'Campo requerido']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="usuario.apellidoPaterno"
                    label="Apellido Paterno*"
                    hint="Ingrese su apellido paterno"
                    :rules="[(v) => !!v || 'Campo requerido']"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="usuario.apellidoMaterno"
                    label="Apellido Materno"
                    hint="Ingrese su apellido materno"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="usuario.correo"
                    label="Email*"
                    hint="Ingrese un correo electrónico válido ya que será el medio de contacto"
                    persistent-hint
                    :rules="[
                      (v) => !!v || 'Campo requerido',
                      (v) => /.+@.+/.test(v) || 'Eliga un correo válido',
                    ]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="usuario.comentarios"
                    label="Comentarios*"
                    required
                    :rules="[(v) => !!v || 'Campo requerido']"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
            <small class="red--text">*Indicador de campo requerido</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="reset(), (dialog = false)"
              >Cerrar</v-btn
            >
            <v-btn
              :disabled="!valid"
              flat
              color="blue darken-1"
              @click="sendMail()"
              >Enviar</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: "academica-email",
  data: () => ({
    dialog: false,
    usuario: {},
    valid: true,
  }),

  methods: {
    sendMail() {
      if (this.$refs.form.validate()) {
        window.open(
          `mailto:${this.representante_email}?cc=seicti@cocyted.gob.mx&subject=Me interesa contactar a su institución &body=Nombre: ${this.usuario.nombre} ${this.usuario.apellidoPaterno} ${this.usuario.apellidoMaterno},%0D%0ACorreo: ${this.usuario.correo},%0D%0AMensaje: ${this.usuario.comentarios},%0D%0A%0D%0AContacto:%0D%0ANombre: ${this.representante_nombre} ${this.representante_apellido_paterno} ${this.representante_apellido_materno},%0D%0ACorreo: ${this.representante_email}`
        );
        this.reset();
        this.dialog = false;
      }
    },

    reset() {
      this.$refs.form.reset();
    },
  },
  props: {
    representante_nombre: String,
    representante_apellido_paterno: String,
    representante_apellido_materno: String,
    representante_email: String,
  },
  computed: {},
};
</script>